// src/mxgraph.ts
import factory from '@deity-io/mxgraph';

(window as any)['mxBasePath'] = 'assets/mxgraph';
(window as any)['mxLoadResources'] = undefined;
(window as any)['mxForceIncludes'] = undefined;
(window as any)['mxResourceExtension'] = undefined;
(window as any)['mxLoadStylesheets'] = undefined;

export default factory({
  // not working see https://github.com/jgraph/mxgraph/issues/479
  mxBasePath: 'assets/mxgraph'
});
